<script>
	import Banner from './Banner.svelte';
	import TopMenu from './TopMenu.svelte';
	import MainPage from './MainPage.svelte';
	import ViewNewEntries from './ViewNewEntries.svelte';
	import Footer from './Footer.svelte';
	import { onMount } from 'svelte';
	
	let page;
	function pageLookup() {
		const urlParams = new URLSearchParams(window.location.search);
		const searchPage = urlParams.get('page');

		if (!searchPage) {
			page = 'main'
		} else { 
			page = searchPage.toLowerCase();
		}
	}
	pageLookup();
</script>

<svelte:head>
    <title>GW2W EM</title> 
</svelte:head>


<Banner />
	<main>
		<h3>{page === 'vne' ? 'View New Entries' : ''}</h3>
		<TopMenu />
		<display>
			{#if page === 'main'}
				<MainPage />
			{:else if page === 'vne'}
				<ViewNewEntries />
			<!--{:else if page === 'dialogue'}
				<DialogueBuilder />
			{:else if page === 'interwikis'}
				<Interwikis />-->
			{/if}
		</display>
	</main>
<Footer />

<style>

	:global(body) {
		min-height: 100%;
		height: 100%;
		padding: 12px;
		padding-right: 0;
		padding-left: 0;
		font-family: 'PT Serif';
		font-style: normal;
		src: local("PT Serif"), local("PTSerif-Regular"), url("https://fonts.gstatic.com/s/ptserif/v8/I-OtoJZa3TeyH6D9oli3ifesZW2xOQ-xsNqO47m55DA.woff2") format("woff2");
  		unicode-range: U+0-FF, U+131, U+152-153, U+2C6, U+2DA, U+2DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215;
	}

	:global(input), :global(select), :global(textarea){
		padding: 0.1em;
		font-family: 'PT Serif';
	}

	:global(textarea) {
		font-size: 13px;
		font-family: monospace;
	}

	:global(#boxes) {
		display: table-cell;
	}

	:global(#icon) {
		display: table-cell;
		vertical-align: top;
		padding-left: 4px;
	}

	main {
		min-height: 75%;
		overflow: auto;
		font-size: 110%;
		padding-bottom: 0px;
	}

	main:after {
		content: "";
		display: block;
		height: 60px;
	}

	h3 {
		text-align: center;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>